import { action, observable, set } from "mobx";
import moment from "moment";
import Model from "~/models/Model";
import UiMeet3dEventNotification from "./UiMeet3dEventNotification";

class UiMeet3dEvent extends Model {
  /**
   * @property {number|null}
   */
  @observable uiMeet3dEventId = null;

  @observable tourId = null;

  @observable creationDts = null;

  @observable data = null;

  @observable uiMeet3dEventNotifications = [];

  @action
  setData(data) {
    const { creationDts, uiMeet3dEventNotifications, ...rest } = data;
    set(this, rest);

    if (uiMeet3dEventNotifications) {
      uiMeet3dEventNotifications.forEach(uiMeet3dEventNotification =>
        this.uiMeet3dEventNotifications.push(new UiMeet3dEventNotification(uiMeet3dEventNotification)),
      );
    }

    this.creationDts = creationDts ? moment.unix(creationDts) : null;
  }
}

export default UiMeet3dEvent;
